import React, { useEffect, useState } from "react";
import { AboutUs } from "../components/home/AboutUs";
import { PopularCourses } from "../components/home/PopularCourses";
import { University } from "../components/home/University";
import { Faculty } from "../components/home/Faculty";
import { NewsEvents } from "../components/home/NewsEvents";
import HomeBanner from "../components/home/HomeBanner";
// import { Link, useLocation } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  fetchHomeAboutUs,
  fetchHomeBanner,
  fetchHomeUniversity,
  fetchNewsEvents,
} from "../api/HomeApi";
import { dynamicFailed } from "../hooks/custom/useToast";
import {
  IHomeAboutUsData,
  IHomeBannerData,
  IHomeUniversityData,
  IMissionVisionData,
  INewsEventsData,
} from "../exports/interfaces";
import { useLoader } from "../context/LoaderContext";
import { fetchMission, fetchVision } from "../api/AboutApi";

const HomePage = () => {
  const location = useLocation();

  const { setLoading } = useLoader();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (location.hash === "#news-events") {
      setTimeout(() => {
        document
          .getElementById("news-events")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);

  const [homeBanner, setHomeBanner] = useState<IHomeBannerData[]>([]);
  const [homeAboutUs, setHomeAboutUs] = useState<IHomeAboutUsData[]>([]);

  const [homeUniverstiy, setHomeUniverstiy] = useState<IHomeUniversityData[]>(
    [],
  );
  const [newsEvents, setNewsEvents] = useState<INewsEventsData[]>([]);
  const [visionStatement, setVisionStatement] = useState<IMissionVisionData[]>(
    [],
  );
  const [missionStatement, setMissionStatement] = useState<
    IMissionVisionData[]
  >([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchHomeBanner(),
      fetchHomeAboutUs(),
      fetchHomeUniversity(),
      fetchNewsEvents(),
      fetchVision(),
      fetchMission(),
    ])
      .then(
        ([
          homeBannerData,
          homeAboutUsData,
          homeUniverstiyData,
          newsEventsData,
          visionStatementData,
          missionStatementData,
        ]) => {
          setHomeBanner(homeBannerData);
          setHomeAboutUs(homeAboutUsData);
          setHomeUniverstiy(homeUniverstiyData);
          setNewsEvents(newsEventsData);
          setVisionStatement(visionStatementData);
          setMissionStatement(missionStatementData);
        },
      )
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  return (
    <>
      <HomeBanner homeBanner={homeBanner} />
      <AboutUs aboutUsData={homeAboutUs} />
      <University
        homeUniversity={homeUniverstiy}
        visionStatement={visionStatement}
        missionStatement={missionStatement}
      />
      <PopularCourses />
      <Faculty />
      <NewsEvents newsEvents={newsEvents} />
    </>
  );
};

export default HomePage;
